import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '@/lang/lang.js'
import store from '@/store/index.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/views/Cms.vue'),
    beforeEnter: async (to, from, next) => {
      if (to.name === 'Dashboard' || to.name === 'Announcements') {
        next()
        return
      }

      try {
        await store.dispatch('getUserInfo')
        let targetRoute = 'Announcements'
        if (store.getters.isSystemManage || store.getters.hasPermission('dashboard.show')) {
          targetRoute = 'Dashboard'
        }
        next({ name: targetRoute, replace: true })
      } catch (error) {
        console.error('Error during navigation:', error)
        next({ name: 'Error' })
      }
    },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/components/Dashboard.vue'),
        meta: {title: '__dashboard'},
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            // 必須直接使用 store.
            if (store.getters.isSystemManage || store.getters.hasPermission('dashboard.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'agent',
        name: 'Agent',
        component: () => import('@/components/Agent.vue'),
        meta: {title: '__agentAccountManagement'},
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.isSystemManage || store.getters.hasPermission('agent.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'agency',
        name: 'Agency',
        component: () => import('@/components/Agency.vue'),
        meta: {title: '__agencyManagement'},
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.isSystemManage || store.getters.hasPermission('agency.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'caringcm',
        name: 'CaringCmInstitution',
        component: () => import('@/components/CaringCmInstitution.vue'),
        meta: {title: '__caringCmManagement'},
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.isSystemManage || store.getters.hasPermission('caringcm.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'user',
        name: 'User',
        component: () => import('@/components/User.vue'),
        meta: {title: '__agencyAccountManagement'},
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.isSystemManage || store.getters.hasPermission('user.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'device',
        name: 'Device',
        component: () => import('@/components/Device.vue'),
        meta: {title: '__deviceCertificateManagement'},
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.isSystemManage || store.getters.hasPermission('device.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'device-control',
        name: 'DeviceControl',
        component: () => import('@/components/DeviceControl.vue'),
        meta: {title: '__deviceManagement'},
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.isSystemManage || store.getters.hasPermission('device.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'device-control/history',
        name: 'DeviceControlHistory',
        component: () => import('@/components/DeviceControlHistory.vue'),
        meta: {title: '__deviceCommandRecord'},
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.isSystemManage || store.getters.hasPermission('device.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'mqtt-route',
        name: 'MqttRoute',
        component: () => import('@/components/MqttRoute.vue'),
        meta: {title: '__mqttRouteManagement'},
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.isSystemManage || store.getters.hasPermission('mqtt-route.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'chiline',
        name: 'Chiline',
        component: () => import('@/components/Chiline.vue'),
        meta: {title: '__chilineManagement'},
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.isSystemManage || store.getters.hasPermission('chiline.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'itracker',
        name: 'ITracker',
        component: () => import('@/components/ITracker.vue'),
        meta: {title: '__itrackerManagement'},
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.isSystemManage || store.getters.hasPermission('itracker.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'fora',
        name: 'Fora',
        component: () => import('@/components/Fora.vue'),
        meta: {title: '__foraManagement'},
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.isSystemManage || store.getters.hasPermission('fora.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'ai-settings',
        name: 'AiSettings',
        component: () => import('@/components/AiSettings.vue'),
        meta: {title: 'AI 設定管理'},
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.isSystemManage || store.getters.hasPermission('ai.settings.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'ai-staff-members',
        name: 'AiStaffMembers',
        component: () => import('@/components/AiStaffMembers.vue'),
        meta: {title: 'AI 客服人員管理'},
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.isSystemManage || store.getters.hasPermission('ai.staff.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'ai-chat-test',
        name: 'AiChatTest',
        component: () => import('@/components/AiChatTest.vue'),
        meta: {title: 'AI 對話測試'},
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.isSystemManage || store.getters.hasPermission('ai.chat.test')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      // {
      //   path: 'device-report',
      //   name: 'DeviceReport',
      //   component: () => import('@/components/DeviceReport.vue'),
      //   meta: {title: '__errorReport'},
      //   beforeEnter: (to, from, next) => {
      //     store.dispatch('getUserInfo').then(() => {
      //       isSystemManage() ? next() : next({name: 'Error'})
      //     })
      //   }
      // },
      {
        path: 'contact',
        name: 'Contact',
        component: () => import('@/components/Contact.vue'),
        meta: {
          title: '__contactUs'
        },
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            store.getters.isSystemManage ? next() : next({name: 'Error'})
          })
        }
      },
      {
        path: 'announcements',
        name: 'Announcements',
        component: () => import('@/components/announcements/Announcements.vue'),
        meta: {
          title: '__announcements'
        },
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.hasPermission('announcements.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'announcements/add',
        name: 'AnnouncementAdd',
        component: () => import('@/components/announcements/AnnouncementAdd.vue'),
        meta: {
          title: '__announcementAdd'
        },
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.hasPermission('announcements.show') &&
              store.getters.hasPermission('announcements.update')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'announcements/:id',
        name: 'AnnouncementEdit',
        component: () => import('@/components/announcements/AnnouncementEdit.vue'),
        meta: {
          title: '__announcementEdit'
        },
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.hasPermission('announcements.show') &&
              store.getters.hasPermission('announcements.update')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'general-settings',
        name: 'GeneralSettings',
        component: () => import('@/components/GeneralSettings.vue'),
        meta: {
          title: '__generalSettings'
        },
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.hasPermission('settings.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'chats',
        name: 'Chats',
        component: () => import('@/components/chats/Chats.vue'),
        meta: {
          title: '__chats'
        },
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.hasPermission('chats.show') &&
              store.getters.hasPermission('chats.update')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'ai-knowledge',
        name: 'AiKnowledge',
        component: () => import('@/components/AiKnowledge.vue'),
        meta: {
          title: 'AI 知識庫'
        },
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.isSystemManage || store.getters.hasPermission('ai.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'ai-documents',
        name: 'AiDocuments',
        component: () => import('@/components/AiDocuments.vue'),
        meta: {
          title: 'AI 文件管理'
        },
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.isSystemManage || store.getters.hasPermission('ai.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'ai-conversations',
        name: 'AiConversations',
        component: () => import('@/components/AiConversations.vue'),
        meta: {
          title: 'AI 對話審核'
        },
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.isSystemManage || store.getters.hasPermission('ai-conversations.view')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'ai-types',
        name: 'AiTypes',
        component: () => import('@/components/AiTypes.vue'),
        meta: {
          title: 'AI 類型管理'
        },
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.isSystemManage || store.getters.hasPermission('ai.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'ai-tags',
        name: 'AiTags',
        component: () => import('@/components/AiTags.vue'),
        meta: {
          title: 'AI 標籤管理'
        },
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.isSystemManage || store.getters.hasPermission('ai.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'notify-reports',
        name: 'NotifyReports',
        component: () => import('@/components/NotifyReport.vue'),
        meta: {
          title: '__notifyManage.title'
        },
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.isSystemManage || store.getters.hasPermission('notify-reports.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'line-group-logs',
        name: 'LineGroupLogs',
        component: () => import('@/components/LineGroupLog.vue'),
        meta: {
          title: '__lineGroupLogs'
        },
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.hasPermission('line-group-logs.show') && store.getters.hasPermission('line-group-logs.update')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'third-party-logs',
        name: 'ThirdPartyLogs',
        component: () => import('@/components/ThirdPartyLog.vue'),
        meta: {
          title: '__thirdPartyLogs'
        },
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.isSystemManage || store.getters.hasPermission('third-party-logs.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'third-party-services',
        name: 'ThirdPartyService',
        component: () => import('@/components/ThirdPartyService.vue'),
        meta: {
          title: '__thirdPartyServiceManagement'
        },
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.isSystemManage || store.getters.hasPermission('third-party-services.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'monthly-reports',
        name: 'MonthlyReport',
        component: () => import('@/components/MonthlyReport.vue'),
        meta: {
          title: '__monthlyReport.title'
        },
        beforeEnter: (to, from, next) => {
          // 後端只認 monthly-report.show，system-manage 不足以呼叫 API
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.hasPermission('monthly-report.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
      {
        path: 'role',
        name: 'Role',
        component: () => import('@/components/Role.vue'),
        meta: {
          title: '__roleManagement'
        },
        beforeEnter: (to, from, next) => {
          store.dispatch('getUserInfo').then(() => {
            if (store.getters.isSystemManage || store.getters.hasPermission('role.show')) {
              next()
            } else {
              next({name: 'Error'})
            }
          })
        }
      },
    ]
  },
  {
    path: '/auth',
    component: () => import('@/views/Auth.vue'),
    redirect: {
      name: 'Login'
    },
    children: [
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/components/auth/Login.vue'),
        meta: {title: '__login'}
      },
      {
        path: 'change-password',
        name: 'Change Password',
        component: () => import('@/components/auth/ChangePassword.vue'),
        meta: {title: '__changeYourPassword'}
      }
    ]
  },
  {
    path: '*',
    name: 'Error',
    component: () => import('@/views/ErrorPage.vue'),
    meta: {title: '404 Error'}
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: 'active',
  linkExactActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('humetrics_token')
  window.document.title = i18n.t(to.meta.title) + ' | ' + i18n.t('__humetrics')
  document.documentElement.lang = i18n.locale

  if (to.name !== 'Login' && !isAuthenticated) {
    next({name: 'Login'})
  } else if (to.name === 'Login' && isAuthenticated) {
    next({name: 'Dashboard'})
  } else {
    next()
  }
})
router.afterEach((to, from) => {
  if (Number(store.state.viewport) < 992 && !store.state.isHideNav) {
    store.commit('HidedNav')
  } else if (Number(store.state.viewport) > 992 && store.state.isHideNav) {
    store.commit('HidedNav')
  }
})
export default router
